export const notLoggedRedirects = [['/turnaje*', '/prihlasenie?redirect=/turnaje']];

const loggedRedirectsArray = [
    ['/prihlasenie*', '/'],
    ['/odhlasenie*', '/'],
    ['/registracia*', '/']
];

const preventRedirectData = [['/turnaje', '/turnaje']];

function preventRedirect(path, redirectSwitch) {
    // eslint-disable-next-line no-unused-vars
    const [_, pathTo] = path;
    if (!redirectSwitch) {
        return pathTo;
    }

    const redirect = preventRedirectData.find(([key]) => key === redirectSwitch);
    return redirect ? redirect[1] : pathTo;
}

export function loggedRedirects(queryRedirect) {
    return loggedRedirectsArray.map(path => [path[0], preventRedirect(path, queryRedirect)]);
}
